import {Injectable} from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { firstValueFrom, forkJoin } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class ConfigService {

  private config: any;

  constructor(private readonly _http: HttpClient) {}

  loadConfig(): Promise<void> {
    if (this.config) {
      return Promise.resolve();
    }

    const configGeral$ = this._http.get('./assets/config/config.json');
    const configAsgard$ = this._http.get('./assets/config/asgard.json');

    return firstValueFrom(forkJoin([configGeral$, configAsgard$]))
      .then(([configGeral, configAsgard]) => {
        this.config = { ...configGeral, ...configAsgard };
      })
      .catch(err => {
        console.error('Erro ao carregar configuração', err);
        throw err;
      });
    }

  getConfig() {
    return this.config ?? {};
  }
}
